// Globale Kontaktdaten für YADE Home GmbH
// Diese Datei enthält alle zentralen Kontaktinformationen

// Feature Flag: Telefonnummer anzeigen oder ausblenden
export const SHOW_PHONE_NUMBER = import.meta.env.VITE_SHOW_PHONE_NUMBER === 'true';

// Firmendaten
export const FIRMA_NAME = 'YADE Home GmbH';
export const FIRMA_TELEFON = '+49 1512 3395244';
export const FIRMA_EMAIL = 'verwaltung@yade-home.de';
export const FIRMA_STRASSE = 'Charles-de-Gaulle-Platz 1d';
export const FIRMA_PLZ = '50679';
export const FIRMA_STADT = 'Köln';
export const FIRMA_LAND = 'Deutschland';

// Formatierte Adressen für verschiedene Verwendungszwecke
export const FIRMA_ADRESSE_KURZ = `${FIRMA_STRASSE}, ${FIRMA_PLZ} ${FIRMA_STADT}`;
export const FIRMA_ADRESSE_KOMPLETT = `${FIRMA_NAME}
${FIRMA_STRASSE}
${FIRMA_PLZ} ${FIRMA_STADT}
${FIRMA_LAND}`;

// Links für HTML
export const TELEFON_LINK = 'tel:+4915123395244';
export const EMAIL_LINK = `mailto:${FIRMA_EMAIL}`;

// Phone obfuscation utilities for bot protection
// Encodes phone number to prevent automated scraping
export const encodePhone = (phone: string): string => {
  // ROT13-like encoding + Base64
  const reversed = phone.split('').reverse().join('');
  return btoa(reversed);
};

export const decodePhone = (encoded: string): string => {
  // Decode Base64 + reverse
  return atob(encoded).split('').reverse().join('');
};

// Obfuscated phone number (encoded at build time)
export const OBFUSCATED_PHONE = encodePhone(FIRMA_TELEFON);

// Strukturiertes Kontakt-Objekt
export const KONTAKT_INFO = {
  name: FIRMA_NAME,
  telefon: FIRMA_TELEFON,
  email: FIRMA_EMAIL,
  strasse: FIRMA_STRASSE,
  plz: FIRMA_PLZ,
  stadt: FIRMA_STADT,
  land: FIRMA_LAND,
  adresseKurz: FIRMA_ADRESSE_KURZ,
  adresseKomplett: FIRMA_ADRESSE_KOMPLETT,
  telefonLink: TELEFON_LINK,
  emailLink: EMAIL_LINK
};

// Helper Functions für Feature-Toggle
/**
 * Gibt die Telefonnummer zurück, wenn das Feature aktiviert ist
 * @returns Telefonnummer oder null
 */
export const getPhoneDisplay = (): string | null => {
  return SHOW_PHONE_NUMBER ? FIRMA_TELEFON : null;
};

/**
 * Gibt den Telefon-Link zurück, wenn das Feature aktiviert ist
 * @returns tel: Link oder '#'
 */
export const getPhoneLink = (): string => {
  return SHOW_PHONE_NUMBER ? TELEFON_LINK : '#';
};

/**
 * Gibt die obfuscierte Telefonnummer zurück, wenn das Feature aktiviert ist
 * @returns Obfuscated phone oder leerer String
 */
export const getObfuscatedPhone = (): string => {
  return SHOW_PHONE_NUMBER ? OBFUSCATED_PHONE : '';
};

/**
 * Prüft, ob Telefonnummern angezeigt werden sollen
 * @returns boolean
 */
export const shouldShowPhone = (): boolean => {
  return SHOW_PHONE_NUMBER;
};
